// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2SH1u","content":"Consent_content__2tjIh","footer":"Consent_footer__3OOCI"};